import { put, takeEvery, delayedPut, call } from '@ers/helpers/redux/sagaEffects';
import { ActionTypes, success,
    warning,
    info,
    error,
    remove } from './toasts.actions';
import AppApi from '../App.api';
import { ToastObject, ToastType } from './Toasts';

const actions = {
    success,
    warning,
    info,
    error
};
function* addSuccess(api, action) {
    const toast = createToast(action, ToastType.Success);
    yield call(add, toast);
}
function* addWarning(api, action) {
    const toast = createToast(action, ToastType.Warning);
    yield call(add, toast);
}
function* addInfo(api, action) {
    const toast = createToast(action, ToastType.Info);
    yield call(add, toast);
}
function* addError(api, action) {
    const toast = createToast(action, ToastType.Error);
    yield call(add, toast);
}
function* removeInfo(api, action) {
    const { id } = action.payload;
    yield put(remove({ id, type: ToastType.Warning }));
}

function createToast(action, type) {
    const { message, dismiss, id } = action.payload;
    const toast = new ToastObject({ type, message, dismiss, id });
    return toast;
}



function* add(toast) {
    const addAction = actions[toast.type]({ payload: { toast } });
    yield put(addAction);
    if (toast.dismiss) {
        yield delayedPut(toast.dismiss, remove(toast));
    }
}


export default function* toastsSaga() {
    const appApi = new AppApi();
    yield takeEvery(ActionTypes.addSuccess, addSuccess, appApi);
    yield takeEvery(ActionTypes.addWarning, addWarning, appApi);
    yield takeEvery(ActionTypes.addInfo, addInfo, appApi);
    yield takeEvery(ActionTypes.addError, addError, appApi);
    yield takeEvery(ActionTypes.removeInfo, removeInfo, appApi);
    // if (process.env.NODE_ENV === 'development') {
    //     yield call(add, new ToastObject());
    // }
}
